const containerWidth = {
  backgroundColor: "white",
  width: "100%",
  maxWidth: "50rem"
}

export default {
  containerWidth
}
